export var RuleType;
(function (RuleType) {
    RuleType[RuleType["LogicalRule"] = 0] = "LogicalRule";
    RuleType[RuleType["DataReturnRule"] = 1] = "DataReturnRule";
    RuleType[RuleType["ActionRule"] = 2] = "ActionRule";
    RuleType[RuleType["MultipleDataRule"] = 3] = "MultipleDataRule";
    RuleType[RuleType["MultipleDataRuleValueOutput"] = 4] = "MultipleDataRuleValueOutput";
})(RuleType || (RuleType = {}));
;
